import React from 'react'

import { ItemProps } from './item.types'

export const Item = ({ value, children }: ItemProps) =>
  value ? <>{children}</> : null
